'use strict';

angular.module('licensure.services')
    .factory('TriggerConfigurations', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/triggerconfigurations', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/triggerconfigurations/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (trigger_configuration) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/triggerconfigurations/';
                if (!isUndefined(trigger_configuration.id)) {
                    method = 'PUT';
                    url += trigger_configuration.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        trigger_configuration: trigger_configuration
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }

        }
    }])
;